import { fetchUtils } from 'react-admin';
import simpleRestClient from 'ra-data-simple-rest';
import {configAPI} from './config';

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = sessionStorage.B.encodeDecode();
    options.headers.set('Authorization', `${token}`);
    options.token = token;

    return fetchUtils.fetchJson(url, options);
}
const restClient = simpleRestClient(configAPI.api.prod, httpClient);


export default (type, resource, params) => new Promise(resolve => setTimeout(() => resolve(restClient(type, resource, params)), 0));
